<template>
<section class="section-slution" :style="{backgroundImage: `url(${webInfo.home.jjfaBg})`}">

        <div class="content">
            <div class="title-section">全场景解决方案</div>

            <div class="body">
                <div
                    class="card card-left"
                    :class="{active: leftActiveController}"
                    ref="left"
                    @mouseover="leftMouseover"
                >
                    <div class="title">
                        传统采购模式存在的问题
                    </div>

                    <div class="list">
                        <div
                            v-for="(item, index) in problemList"
                            :key="index"
                            class="item"
                        >
                            <div class="title">
                                <i class="el-icon-error"></i>
                                {{item.title}}
                            </div>
                            <div class="text">
                                {{item.text}}
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="card card-right"
                    :class="{active: rightActiveController}"
                    ref="right"
                    @mouseover="rightMouseover"
                >
                    <div class="title">
                        {{this.webInfo.webName}}平台解决方案
                    </div>

                    <div class="list">
                        <div
                            v-for="(item, index) in resolveList"
                            :key="index"
                            class="item"
                        >
                            <div class="title">
                                <i class="el-icon-success"></i>
                                {{item.title}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        webType: {
            type: String,
            default: 'hzc', // hzc hzyc
        }
    },
    data() {
        return {
            problemList: [
                {
                    title: '采购流程繁琐，耗时长',
                    text: '从供应商管理、寻源操作到合同签订、订单执行，业务流程长，审批节点多，传统管理透明度低，联动性差。',
                },
                {
                    title: '供应商管理困难',
                    text: '供应商源头少且身份资质审查验难，风控滞后。',
                },
                {
                    title: '内外协同难',
                    text: '采、供双方协同角色涉及业、财、法多部门，口径多，流程长。',
                },
                {
                    title: '文档管理难',
                    text: '招投标文件、合同及相关附件、协议、变更等涉及文档较多，留档保存管理难度大。',
                },
                {
                    title: '成本风险难控制',
                    text: '无法进行全面的价格比对，缺乏成本评判依据，内部采购计划性差，缺少执行预测和控制预警，采购被动。',
                },
            ],

            resolveList: [
                {
                    title: '通过自动化流程、数字化管理等方式，大大缩短采购流程的时间，减少人工操作的繁琐。',
                },
                {
                    title: '通过供应商库、供应商绩效评估等功能，帮助客户更好地管理供应商，提高供应链的效率和稳定性。',
                },
                {
                    title: '实现外部供应商准入、寻源、执行、结算全过程协同；内部采购、法务、质量、仓库、财务全角色协作。',
                },
                {
                    title: '通过数字化、智能化的方式来对文档进行统一归档和处理，提高工作效率和信息安全性。',
                },
                {
                    title: '通过采购成本分析、采购报价订单统计/采购风险报表、供应商合规性评估等功能，帮助客户更好地控制采购成本，把控采购风险。',
                },
            ],

            leftActiveController: false,
            rightActiveController: true,
            
        };
    },
    methods: {
        leftMouseover() {
            this.leftActiveController = true;
            this.rightActiveController = false;
        },
        rightMouseover() {
            this.leftActiveController = false;
            this.rightActiveController = true;
        },
    },
    mounted(){
        
    },
};
</script>

<style lang="scss" scoped>
.section-slution {
    background-size: cover;
    background-position: center center;

    .title-section {
        color: white;
        padding: 58px 0 55px;
        font-weight: normal;
    }

    .body {
        position: relative;
        height: 558px;

        .card {
            border-radius: 8px;
            padding: 18px 24px;
            color: #222222;
            width: 670px;
            cursor: default;
            position: absolute;
            top: 0;
            overflow: hidden;
            background-size: 100% 100%;
            opacity: 0.8;
            transition: all 0.3s;
            transform: scale(0.9);
            transform-origin: top;

            &.active {
                opacity: 1;
                transform: scale(1);
            }

            & > .title {
                font-size: 22px;
                color: #222222;
                line-height: 1em;
                position: relative;
                padding-bottom: 18px;

                &:after {
                    content: '';
                    display: block;
                    width: 474px;
                    height: 1px;
                    background: #d9d9d9;
                    position: absolute;
                    bottom: 0;
                }
            }

            &.card-left {
                left: 0;
                background-image: url(/images/hzc/home/bg-trapezoid-l.png);

                & > .title {
                    &:after {
                        left: 0;
                    }
                }
            }

            &.card-right {
                right: 0;
                background-image: url(/images/hzc/home/bg-trapezoid-r.png);

                & > .title {
                    text-align: right;

                    &:after {
                        right: 0;
                    }
                }

                .list {
                    float: right;

                    .item {
                        i {
                            color: #1a69ff;
                        }

                        & + .item {
                            margin-top: 40px;
                        }
                    }
                }
            }

            .list {
                padding: 18px 0;
                width: 527px;

                .item {
                    .title {
                        display: flex;
                        align-items: center;

                        i {
                            font-size: 18px;
                            margin-right: 6px;
                        }
                    }

                    .text {
                        font-size: 13px;
                        padding-left: 24px;
                        margin-top: 8px;
                    }

                    & + .item {
                        margin-top: 22px;
                    }
                }
            }
        }
    }
}
</style>